import { useState } from 'react';
import { Download } from 'lucide-react';
import { auditCsvUrl, useAudit } from '@/hooks/useAudit';

export function AuditPage() {
  const [action, setAction] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [page, setPage] = useState(1);

  const q = {
    action: action || undefined,
    from: from ? new Date(from).toISOString() : undefined,
    to: to ? new Date(to).toISOString() : undefined,
    page,
    page_size: 50,
  };
  const list = useAudit(q);
  const totalPages = list.data ? Math.max(1, Math.ceil(list.data.total / list.data.page_size)) : 1;

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-moss-200">Auditoría</h1>
          <p className="mt-1 text-sm text-moss-300/70">
            Cada acción de usuario queda registrada de forma append-only.
          </p>
        </div>
        <a className="btn-ghost" href={auditCsvUrl(q)} target="_blank" rel="noreferrer">
          <Download className="mr-1.5 h-4 w-4" />
          Exportar CSV
        </a>
      </div>

      <div className="glass-card flex flex-wrap items-end gap-3 p-3">
        <div className="flex-1 min-w-[160px]">
          <label className="text-xs uppercase tracking-wide text-moss-300/70">Acción</label>
          <input
            value={action}
            onChange={(e) => {
              setAction(e.target.value);
              setPage(1);
            }}
            placeholder="client.pagar, login.success…"
            className="input-base mt-1"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wide text-moss-300/70">Desde</label>
          <input
            type="datetime-local"
            value={from}
            onChange={(e) => {
              setFrom(e.target.value);
              setPage(1);
            }}
            className="input-base mt-1"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wide text-moss-300/70">Hasta</label>
          <input
            type="datetime-local"
            value={to}
            onChange={(e) => {
              setTo(e.target.value);
              setPage(1);
            }}
            className="input-base mt-1"
          />
        </div>
      </div>

      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-ink-700/70 bg-ink-800/40 text-left text-xs uppercase tracking-wide text-moss-300/70">
              <tr>
                <th className="px-4 py-3">Fecha</th>
                <th className="px-4 py-3">Usuario</th>
                <th className="px-4 py-3">Acción</th>
                <th className="px-4 py-3">Objetivo</th>
                <th className="px-4 py-3">IP</th>
                <th className="px-4 py-3">Resultado</th>
              </tr>
            </thead>
            <tbody>
              {list.isLoading && (
                <tr>
                  <td colSpan={6} className="p-8 text-center text-moss-300/60">
                    Cargando…
                  </td>
                </tr>
              )}
              {list.data?.rows.map((r) => (
                <tr key={r.id} className="border-b border-ink-700/40 last:border-0 hover:bg-ink-700/30">
                  <td className="whitespace-nowrap px-4 py-3 font-mono text-xs text-moss-300">
                    {new Date(r.ts).toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-moss-200">{r.user_email ?? '—'}</td>
                  <td className="px-4 py-3 font-mono text-xs text-mustard-300">{r.action}</td>
                  <td className="px-4 py-3 text-moss-300">
                    {r.server_name ? `${r.server_name}${r.db_name ? ` · ${r.db_name}` : ''}` : '—'}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-moss-300">{r.ip}</td>
                  <td className="px-4 py-3">
                    {r.success ? <span className="pill-ok">OK</span> : <span className="pill-danger">Falló</span>}
                  </td>
                </tr>
              ))}
              {list.data?.rows.length === 0 && (
                <tr>
                  <td colSpan={6} className="p-10 text-center text-moss-300/60">
                    Sin entradas para los filtros actuales.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list.data && list.data.total > list.data.page_size && (
          <div className="flex items-center justify-between border-t border-ink-700/70 bg-ink-800/40 px-4 py-3 text-xs text-moss-300/70">
            <div>
              Página {list.data.page} de {totalPages} · {list.data.total} resultados
            </div>
            <div className="flex gap-2">
              <button className="btn-ghost h-8 px-3 text-xs" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={list.data.page <= 1}>
                Anterior
              </button>
              <button className="btn-ghost h-8 px-3 text-xs" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={list.data.page >= totalPages}>
                Siguiente
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
